<template>
  <component :is="component" v-if="component" />
</template>

<script>
import { FALLBACK_NEW_POST_PB_TRACKING } from '@front/common/constants'
import useGrowthbook from '@front/common/hooks/useGrowthbook'
import { FlowType } from '@front/common/types'
import { computed, defineComponent, ref, watch } from '@vue/composition-api'
import { useVuex } from '@vueblocks/vue-use-vuex'

import Default from './components/default.vue'
import New from './components/new.vue'

export default defineComponent({
  setup() {
    const growthbook = useGrowthbook()
    const { useGetters } = useVuex()
    const isGrowthbookLoaded = ref(false)

    const { flow } = useGetters({
      flow: 'profileBuilder/getFlow',
    })

    // Watch for when growthbook becomes available
    watch(
      growthbook,
      (newGrowthbook) => {
        if (newGrowthbook) {
          isGrowthbookLoaded.value = true
        }
      },
      { immediate: true },
    )

    const component = computed(() => {
      // TODO : Remove after ab testing on transition pages finished
      if (
        flow.value !== FlowType.classic &&
        flow.value !== FlowType.transition
      ) {
        return New
      }

      // Wait for growthbook to load before making decisions
      if (!isGrowthbookLoaded.value || !growthbook.value) {
        return null
      }

      return growthbook.value?.getFeatureValue?.(
        'new-post-pb-pages',
        FALLBACK_NEW_POST_PB_TRACKING,
      ) === 'new'
        ? New
        : Default
    })

    return { component }
  },
})
</script>
